import type { JSX } from "react";

export type SegmentProgressIndicatorProps = {
  isStreaming: boolean;
};

// ストリーミング中に最終セグメント末尾へ表示する「生成中」アニメーション。
// LoadingOverlay の代替として、段落の流れを損なわずに進行中状態を伝える（要件 4.5）。
export function SegmentProgressIndicator({
  isStreaming,
}: SegmentProgressIndicatorProps): JSX.Element | null {
  if (!isStreaming) return null;

  return (
    <span
      data-testid="segment-progress-indicator"
      className="inline-flex items-center gap-1 ml-2"
      aria-label="生成中"
    >
      {/* 3 つのドットを順番にフェードさせて「生成中」を表現する */}
      <span
        data-dot
        className="w-1.5 h-1.5 rounded-full bg-indigo-400 animate-bounce [animation-delay:-0.3s]"
      />
      <span
        data-dot
        className="w-1.5 h-1.5 rounded-full bg-indigo-400 animate-bounce [animation-delay:-0.15s]"
      />
      <span
        data-dot
        className="w-1.5 h-1.5 rounded-full bg-indigo-400 animate-bounce"
      />
    </span>
  );
}
